import { CenterAlignedLoader, removeAllToasts } from '@medly-components/core';
import { ReactNode, useEffect } from 'react';

import { errorToast } from 'utils/utils';
import { useAuth } from '../../../hooks/useAuth/useAuth';

/**
 * AdminProtectedRoute responsible for protected route against admin user to see all users info.
 */
export const AdminProtectedRoute = ({ children }: { children: ReactNode }) => {
    const { authorizeAdmin, error, loading } = useAuth();

    useEffect(() => {
        authorizeAdmin();
    }, []);

    useEffect(() => {
        errorToast(error);
        return () => {
            removeAllToasts();
        };
    }, [error]);

    if (loading) {
        return <CenterAlignedLoader />;
    }

    if (error) {
        return null;
    }

    return <>{children}</>;
};
